import styled from 'styled-components';
import { ON_CLICK_OPEN_COLUMNS } from '../../../../constants';

export const SegmentContainer = styled.div`
  height: 100%;
  display: flex;
`;

export const SegmentPane = styled.div`
  width: 560px;
  background: #ffffff;
  box-shadow: 0px 4px 7px rgba(0, 0, 0, 0.05);
`;

export const TablePane = styled.div`
  flex: 1;
  overflow: auto;
  height: 100%;
  display: flex;
  table {
    border-radius: 4px;
    overflow: hidden;
  }
  .fui-table {
    display: flex;
  }
  .table-actions {
    border-bottom: unset;
    box-shadow: unset;
    z-index: 1100;
    background-color: #fbfbfb;
    width: calc(100vw - 624px);
    position: fixed;
  }
  .pagination-text {
    text-align: center;
    padding: 0 8px;
  }
  .table-content {
    margin-top: 56px;
  }
  .table-wrapper {
    padding: unset;
    overflow: auto;
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  th {
    padding: 12px 12px;
    text-align: left;
  }
  td {
    padding: 12px 12px;
    white-space: nowrap;
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 12px 12px;
    white-space: nowrap;
  }
  ${ON_CLICK_OPEN_COLUMNS.map((cn) => `td.${cn}`).join(', ')} {
    cursor: pointer;
    :hover {
      color: #2c5cc5;
    }
  }
`;
